import { Emphasis } from "@lya-protect/lya-protect-form-library/dist/UI";
import Collapse from "@src/components/collapse/Collapse";
import SvgKeyboardArrowDown from "@src/components/icons/KeyboardArrowDown";
import SvgKeyboardArrowUp from "@src/components/icons/KeyboardArrowUp";
import ACTIVITES from "@src/Steps/simulate/activities/activitiesConfig";
import { _Activity } from "@src/Steps/simulate/activities/Activities";
import { CollapseElement } from "@src/Steps/simulate/tarif/components/CollapseElement";
import { useState, useMemo } from "react";
import { ActivitiesProps } from "@src/Steps/step/Steps";
import "./simulationPrestationsCollapse.scss";

export type SimulationPrestationsCollapseProps = {
  visibleActivities: _Activity[];
  headerClassName?: string;
  title?: string;
};

export function SimulationPrestationsCollapse({
  visibleActivities,
  headerClassName = "tarif-desktop-step__header",
  title = "Simuler mes prestations au titre du contrat Paxivie",
}: SimulationPrestationsCollapseProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="main-collapse-element main-collapse-element__wrapper">
      <button
        type="button"
        className="main-collapse-element main-collapse-element__wrapper-title"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        <h2>{title}</h2>
        <div className="main-collapse-element__wrapper-title-color">
          {isOpen ? <SvgKeyboardArrowUp /> : <SvgKeyboardArrowDown />}
        </div>
      </button>
      <Collapse isOpened={isOpen} className="main-collapse-element__inside">
        <div className={headerClassName}>
          <h2>
            Exemples d&apos;
            <Emphasis>accidents couverts </Emphasis>
            par votre contrat Paxivie
          </h2>
        </div>
        {visibleActivities.map((activity: _Activity) => (
          <CollapseElement key={activity.name} activity={activity} />
        ))}
      </Collapse>
    </div>
  );
}
